export default "__VITE_ASSET__BYWOJDr$__"